module.exports = __webpack_public_path__ + "assets/img/img-default.4c436d85.jpg";